module.exports = __webpack_public_path__ + "static/media/login-shape-secondary.ce35b24f.png";